import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppStatic, ContentService, SeoService, TypableService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { ActivatedRoute } from '@angular/router';
// import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Subject, takeUntil } from 'rxjs';


// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
  // animations: [
  //   trigger('activeServiceChange', [
  //     transition('* => *', [
  //       query(':self', [
  //         style({height: '{{startHeight}}px'})
  //       ]),
  //       query(':enter', [
  //         style({opacity: 0, scale: 0.9})
  //       ], { optional: true }),
  //       query(':leave', [
  //         style({opacity: 1, scale: 1, height: '*'}),
  //         animate('1ms ease-in', style({opacity: 0, scale: 0.5, height: '{{startHeight}}px'}))
  //       ], { optional: true }),
  //       group([
  //         query(':self', [
  //           animate('500ms ease-in', style({height: '*'}))
  //         ]),
  //         query(':enter', [
  //           animate('500ms ease-in', style({opacity: 1, scale: 1}))
  //         ], { optional: true }),
  //       ], { params: { startHeight: 0 } })
  //     ])
  //   ])
  // ]
})
export class ServiceComponent implements OnInit, OnDestroy {


  // @ViewChild('aboutServicesSection') aboutServicesSection: ElementRef

  slug: string //  = 'service'
  content: any
  fields: any

  hoveringServiceIndex: number
  typableIntersectionObserver: any

  metadataSlugs = [
    'service-page-category-description-length-max',
    'service-page-category-item-count-max',
    'learn-more-arrow-1'
  ]
  metadata: any = {}
  descriptionPlaceholder: string

  destroy$: Subject<boolean> = new Subject<boolean>();

  // learnMoreArrowMedia: any

  constructor(
    private route: ActivatedRoute,
    // private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    protected typableService: TypableService,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    // console.log('activeService', this.activeService())
    this.slug = 'service--' + this.route.snapshot.params['slug']
    // console.log('CHECK slug', this.slug)

    this.getMetadata()
    this.getPage()
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    // if (this.fragment$) this.fragment$.unsubscribe()
    // if (this.route$) this.route$.unsubscribe()
  }

  getMetadata() {
    this.contentService.getMetadata({'fields.slug[in]': this.metadataSlugs.join(',') }) // { slug: 'scroll-arrow-icon' })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (meta: any) => {
        try {
          if (!meta.items[0]) return console.log('ERR: !meta', meta)
          
          for (let item of meta.items) {
            let val = item.fields['value']
            if (item.fields['type'] == 'number') val = +val
            this.metadata[item.fields['slug']] = val // NOTE: ALL NUMBERS this time
          }
          const descriptionPlaceholderArray = Array(this.metadata['service-page-category-description-length-max']).fill('x')
          this.descriptionPlaceholder = descriptionPlaceholderArray.join('')
          // console.log('CHECK: meta', this.descriptionPlaceholder, this.metadata)
        } catch {
          console.log('ERR: getMetadata', meta)
        }
      }
    })
  }

  getPage(){
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        if (!this.content.items[0]) return this.seoService.update({ title: 'service not found', noindex: true })
        this.fields = this.content.items[0].fields
        const title = this.fields['title']
        const description = SeoService.text(this.fields['subheading'], `${title} from lowercase productions, a San Francisco-based visual design and communications agency transforming ideas into standout solutions.`)
        this.seoService.update({
          title,
          description,
          // banner is an icon, so the default og image is used
        })
        this.seoService.setStructuredData([
          {
            '@type': 'Service',
            '@id': this.seoService.url() + '#service',
            name: title,
            // 'our marketing & outreach services' => 'marketing & outreach'
            serviceType: title.replace(/^our\s+/i, '').replace(/\s+services?$/i, ''),
            description: SeoService.truncate(description, 300),
            url: this.seoService.url(),
            provider: SeoService.organizationRef(),
          },
          SeoService.breadcrumbs([['services', '/services'], [title, '/services/' + this.route.snapshot.params['slug']]]),
        ])
        // console.log('fields', this.fields)
        setTimeout(() => {
          this.initIntersectionObservers()
        }, 500)
      }
    });
  }

  initIntersectionObservers() {
    if (!AppStatic.isBrowser) return
    const mobileWrappers = document.getElementsByClassName('typable-wrapper-mobile')
    if (!mobileWrappers) return console.log('!mobileWrappers')
    const mobileWrappersArray = Array.prototype.slice.call( mobileWrappers )

    for (const [i, el] of mobileWrappersArray.entries()) {      
      const mobileServiceElement = el.querySelector('.typable-container')
      // console.log('CHECK mobileServiceElements', mobileServiceElement)
      const block = this.fields['sections'][1].fields['items'][i]
      if (!block) console.log('ERR: initIntersectionObserver !block')
      this.typableIntersectionObserver = this.typableService.initIntersectionObserver(mobileServiceElement, { block: block, removeCursorAfterTyping: true })
    }
  }

  // async handleHoverCategory(params={}) {
  //   if (this.hoveringServiceIndex == params['index']) return // console.log('isHoveringServiceIndex', this.hoveringServiceIndex, params['index'])
  //   this.hoveringServiceIndex = params['index']

  //   params['removeCursorAfterTyping'] = true

  //   this.typableService.typeText(params)
  // } 

  async handleHoverCategory(params={}) {
    // const block = params['block']
    // delete params['block']

    const evt = params['event']
    const container = evt && evt.target && evt.target.closest('.typable-container')
    const typableTextElement = container.querySelector('.typable-text')
    const textParams = Object.assign({}, params, { typableTextElement: typableTextElement })
    // console.log('TODO: link', block)
    const wasTyped = await this.typableService.typeText(textParams)
    // console.log('wasTyped', wasTyped)
    if (!wasTyped) return // console.log('CHECK !wasTyped')

    // const linkAddress = block.fields['linkAddress']
    // const linkText = block.fields['linkText']
    // if (linkText && linkAddress) {
    //   const typableTextElement = container.querySelector('.typable-link')
    //   const linkParams = Object.assign({}, params, { link: { text: linkText, address: linkAddress }, typableTextElement: typableTextElement, repeatable: true })
    //   this.typableService.typeText(linkParams)
    // }
  } 

  handleBlurCategory(params={}) {
    // console.log('TODO: handleBlurCategory', params)
    // setTimeout(() => { if (this.hoveringServiceIndex == params['index']) this.hoveringServiceIndex = null }, 1)

    // const evt = params['event']
    // if (!evt) console.log('ERR: handleBlurService !evt', params)
    // const typableTextElement = this.typableService.typableTextElementWithinContainer(evt && evt.target)
    // if (!typableTextElement) return console.log('ERR: !typableTextElement')
    
    // // this.lcpHelper.stopTypingElement(typableTextElement)
    // typableTextElement.classList.remove('is-typed')
    // typableTextElement.innerHTML = null
    // // console.log('TODO: handleBlurService', params)
  }

  
  documentToPlainTextString(doc) {
    return documentToPlainTextString(doc)
  }

  handleSelectCategory(block) {
    // console.log('TODO: handleSelectCategory?', block)
    // this.router.navigate(block.fields['linkAddress'])
  }

}
